export default {
    index:{
        iconav1:'financial',
        iconav2:'stable',
        iconav3:'New products',
        iconav4:'Novice gift bag',
        iconav5:'security',
        iconav6:'Public information',
        iconav7:'reasonable',
        iconav8:'About us',

        hottitle:'Hot List',
        weekrhot:'Hot this week',
        buybtn : 'Go panic buying',
        rate : 'Earnings in the past year',

        yjtitle : 'Stable key optimization',
        dqtitle : 'Short-term financial management',
        sytitle : 'Revenue leader',

        sstitle : 'Platform security operation',
        day : 'day',
        yy : 'yuan',
        wp : 'people',
        safe_desc1 : 'Stable operation',
        safe_desc2 : 'Transaction amount',
        safe_desc3 : 'Number of service users',

    },
    error:{
        error_400 : 'Server Error',
        error_401 : 'Login timed out, please log in again!',
        error_1001 : 'Invalid argument',
        error_1002 : 'Parameter is empty',
        error_1003 : 'Parameter type error',
        error_1004 : 'Missing parameters',
        error_2001 : 'User is not logged in',
        error_2002 : 'The account does not exist or the password is wrong',
        error_2003 : 'Account has been disabled',
        error_2004 : 'User does not exist',
        error_2005 : 'User already exists',
        error_3001 : 'Creation failed',
        error_4001 : 'The system is busy, please try again later',
        error_5001 : 'Data not found',
        error_5002 : 'The data is wrong',
        error_5003 : 'Data already exists',
        error_6004 : 'Invalid interface address',
        error_6005 : 'Interface request timed out',
    },
    login:{
        phone : 'mobile',
        Forget : 'Forgot password',
        Reg   : 'New User Registration',
        login  : 'Log in',
        agreement  : 'The login representative has read and agreed to the "Service Agreement" and "Privacy Agreement"',
        password : 'password',
        phone_msg: 'Please enter the phone number',
        pass_msg: 'Please enter the password'
    },
    reg:{
        reg : "register",
        sendsms: "Send code",
        agreement: "The registered representative has read and agreed to the \"Service Agreement\" and \"Privacy Agreement\"",
        repassword : 'Confirm Password',
        sms:"SMS verification code",
        sms_msg : "Please enter the SMS verification code",
        vaildphone:"Please enter the correct phone number",
        reppass:"The two passwords are inconsistent",
        vading : "Verifying...",
        sendok : "Sent successfully",
        sendfail: "Failed to send",
        sendphone:"Mobile phone number has been registered",
        sendvaid: "Please enter the above content before sending the verification code"


    },
    forget:{
        btnedit:"change Password",
        pagetitle:"Retrieve password",
        submitok:"Successfully modified",
        submitfail: "fail to edit"
    },
    details:{
        pagetitle: 'Product Details',
        qryear : 'Seven-day annualized rate',
        qx:'Project deadline',
        lilu:'interest rate',
        etitle: 'basic information',
        proname: 'Full name of the project',
        pronano: 'Project code',
        prorisk: 'project type',
        protime: 'Date of establishment',
        proscale: 'Project scale',
        start_threshold: 'Starting amount',
        term: 'Project deadline',
        is_repeat: 'Can reinvest',
        insurance: 'Project insurance',
        dettitle: 'details',
        buyMoney: 'purchasing price',
        buyMsg: 'Please enter the purchase amount',
        buy: 'Buy now',
        buyok: 'Successful purchase',
        buyfail: 'Failed purchase',
    },
    prolist:{
        pagetitle: 'Steady financial management',
        mintitle : 'Featured Recommended',
        comment : 'Reviews',
        m1title : 'Short-term financial management',
        m2title : 'Stable key optimization',
        m3title : 'Revenue leader',
    },
    me:{
        amount: "Balance",
        frozen: "Frozen amount",
        icotitle1: "Recharge",
        icotitle2: "withdraw",
        icotitle3: "online service",
        icotitle4: "Financial",
        icotitle5: "information",
        linktitle1: "Personal information",
        linktitle2: "My investment",
        linktitle3: "Recommend a friend",
        linktitle4: "my information",
        linktitle5: "Download APP",
        linktitle6: "Language switch",
        linktitle7: "Agent Center",
        logout : "sign out",
        jstitle : 'quit',
        jscom  : 'Are you sure to log out？'
    },
    userinfo:{
        username:'username',
        name:'Name',
        rename: 'actual name',
        moneyAddr : 'Receiving address',
        moneyStr : 'Wallet address',
        tj   : 'submit',
        avatar : 'Avatar',
        pagetitle : 'Personal information',
        user_tips : 'please enter username',
        mobile_tips : "Please fill in the phone",
        name_tips : 'Please fill in your real name',
        money_tips : 'Please fill in the correct payment address',
        update_tips : 'No data has been modified',
        format_tips : 'Please upload a picture in jpg or gif or png format',
        size_tips : 'The picture cannot be larger than 3M'
    },
    recharge:{
        chargetype: 'Top-up type',
        usdt: 'USDT',
        ylcharge: 'UnionPay',
        czmoney: 'amount',
        inmoney: 'Please enter the amount',
        rinmoney: 'Please enter the correct amount',
        tips_title: 'Precautions',
        charge_tips: 'After submitting the recharge, you need to wait for a while, we will deal with it in time! If the account is not received in time, please contact customer service!',
    },
    withdrawal : {
        pagetitle : 'withdraw',
        txmoney : 'Amount',
        tx_info : 'After submitting the recharge, you need to wait for a while, we will deal with it in time! If the account is not received in time, please contact customer service!',
        tx_ok : 'Withdraw successfully',

    },
    financial : {
        pagetitle : 'Financial details',
        tabtitle1 : 'all',
        tabtitle2 : 'Recharge',
        tabtitle3 : 'withdraw',
        tabtitle4 : 'invest',
        tabtitle5 : 'Give away',
        tabtitle6 : 'income',
        noMore : 'No more',
        updatedata : '{Count} data updated'
    },
    my_investment : {
        pagetitle : 'My investment'
    },
    share : {
        pagetitle : 'Share friends',
        nanoid : 'My referral code',
        myfriend : 'My recommended friend',
        levelfriend : 'Member of the {value} level',
    },
    message :{
        pagetitle : 'my information',
        tabtitle1 : 'All news',
        tabtitle2 : 'system information',
        tabtitle3 : 'Platform notification',
        loading : 'Loading...'
    },
    app_down : {
        pagetitle : 'app download',
    },
    system :{
        back : 'Back',
        project : "Project",
        home : 'Home',
        kefu : 'Contact',
        me : 'Me',
        lang: 'switch language'
    },
    recommend:{
        noContent : 'No content',
        newProject : 'Latest products'
    }

}
